import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { Box, Flex } from '@chakra-ui/react'
import '../styles/dsr-display.scss'
import { MdError } from 'react-icons/md'
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton'
import { signOut } from '../../auth/actions/auth-actions'
import LaunchdeckModal from '../../global/components/helper-components/components/LaunchdeckModal'


function LoggedOutConfirmationModal({ signOut, allUserDsrs, userAccountProfile }) {

  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (allUserDsrs) {
      const { logUserOut } = allUserDsrs || {};

      if (!!logUserOut) {
        setShowModal(true)
      }
    }

  }, [allUserDsrs]);

  useEffect(() => {
    if (userAccountProfile) {
      const { logUserOut } = userAccountProfile || {};

      if (!!logUserOut) {
        setShowModal(true)
      }
    }

  }, [userAccountProfile]);

  const handleClickButton = () => {
    signOut();
  }

  function displayContent() {
    return (
      <Box w='100%' p='1em 1.8em'>
        <Flex w="100%" fontSize='0.875em' color='brandDark.500'>
          Your Administrator has logged you out of your account.
        </Flex>

        <Flex mt='1.625em' w='100%' justify={['center', 'flex-end']}>
          <LaunchdeckButton bg='brandPink.500' w={['100%', 'auto']} color='white' fontSize='0.8em' py='0.4em' onClick={() => handleClickButton()} label='OK' />
        </Flex>
      </Box>
    )
  }

  return (
    <LaunchdeckModal
      title={<Flex gap='1em' justify='flex-start' align='center'>
        <Box as={MdError} color='brandPink.500' boxSize="1.6em" />
        <Box color='white'>You have been logged out</Box>
      </Flex>}
      showModal={showModal}
      maxW='35em'
      noCancelOption={true}
    >
      {displayContent()}
    </LaunchdeckModal>
  )
}

function mapStateToProps(state) {
  return {
    allUserDsrs: state.allUserDsrs.results.data,
    userAccountProfile: state.userProfile.accountUserProfile,
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      signOut
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoggedOutConfirmationModal));
